import React from "react";
import { THEME_DICTIONARY } from "consts";
import "./CustomTable.scss";
//
import {
    makeStyles,
    useTheme,
    useMediaQuery,
    Paper,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    tableHeadCell: {
        backgroundColor: theme.palette.type === THEME_DICTIONARY.LIGHT ? "#fafafa" : "#363636",
    },
}));

function ResultTable(props) {
    const { headers, rows, rowKeyName } = props;
    const theme = useTheme();
    const classes = useStyles();
    const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
    const rowIds = headers.map((header) => header.key);

    const getCellValue = (key, value, header) => {
        const mapper = header && header.mapper;

        if (!mapper) {
            return (
                <TableCell key={key} align={header.align || "right"}>
                    {value}
                </TableCell>
            );
        }

        return (
            <TableCell key={key} align={header.align || "right"}>
                {mapper(value)}
            </TableCell>
        );
    }

    return (
        <Paper className="result-table-wrapper">
            <TableContainer className="table-container">
                <Table className="table" size={isMdUp ? "medium" : "small"} stickyHeader>
                    <TableHead>
                        <TableRow>
                            {headers.map((header, i) => (
                                <TableCell
                                    key={i}
                                    align={header.align || "right"}
                                    className={classes.tableHeadCell}
                                >
                                    {header.name}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows !== null &&
                            rows.map((row, i) => (
                                <TableRow key={rowKeyName ? row[rowKeyName] : i} hover>
                                    {rowIds.map((rowKey, i) =>
                                        getCellValue(rowKey, row[rowKey], headers[i])
                                    )}
                                </TableRow>
                            ))}
                        {(!rows || rows.length === 0) && (
                            <TableRow>
                                <TableCell align="center" colSpan={headers.length}>
                                    {rows === null && <b />}
                                    {rows && rows.length === 0 && <b>No entries</b>}
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
}

export default ResultTable;
